module.exports = __webpack_public_path__ + "img/premium-tag-03-en.ec8e3aaa.svg";